import { endImpersonation } from '@pa/api/admin'
import { forgetStartedImpersonation, readStartedImpersonation } from './state'

/**
 * Admin sign-out while an impersonation this tab started may still be open (T-A05-02): #58 `?reason=sign_out`,
 * best effort (`404` or an ended session is fine: #58 is idempotent).
 */
export async function endStartedImpersonation(): Promise<void> {
  const id = readStartedImpersonation()
  if (!id) return
  forgetStartedImpersonation()
  try {
    await endImpersonation(id, { reason: 'sign_out' })
  } catch {
    // best effort
  }
}
